import { GetImages } from "../../../utils/GetImages";
import { TextCss } from "../../GlobalCss/TextCss";

const SelectType = ({
  title,
  firstOption,
  secondOption,
  icon1,
  icon2,
  selectBasic,
  setSelectBasic,
  handleNext,
  showNextBtn = true,
}) => {
  const options = [
    {
      id: "1",
      label: firstOption || "Onboard New Tenant",
      icon: icon1 || GetImages.OnboardNewTenant,
      description:
        "A fully digital lease renewal process where tenants can review, sign, and submit the lease agreement.",
    },
    {
      id: "2",
      label: secondOption || "Existing Tenant",
      icon: icon2 || GetImages.ExistingTenant,
      description:
        "A manual renewal process where tenants or landlords upload a signed lease agreement.",
    },
  ];

  const handleSelect = (label) => {
    setSelectBasic(label);
    localStorage.setItem("TenantType", label);

    handleNext();
  };

  return (
    <div className="newTenantSelectType" id="tenantFormContainer">
      <div className="newTenantFormTopBar">
        <p className={TextCss.black.main_heading_700_20}>
          {title
            ? `Upload Lease How would you renew lease?`
            : "Select Tenant Type"}
        </p>
      </div>

      <div className="d-flex justify-content-center gap-3">
        {options.map(({ id, label, icon, description }) => (
          <div
            key={id}
            onClick={() => handleSelect(label)}
            className="tenantTypeCards clickable secondary-bg"
          >
            <div className="d-flex flex-column align-items-center gap-3">
              <img src={icon} alt={label} className="color-white-icon"/>
              <div>
                <p className={TextCss.black.heading_700_16}>{label}</p>
                <p className={TextCss.black.normal_text_400_14}>
                  {description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectType;
